import {APP_INITIALIZER, ErrorHandler, LOCALE_ID, NgModule} from '@angular/core';
import {registerLocaleData} from '@angular/common';
import localeDe from '@angular/common/locales/de';
import {BrowserModule} from '@angular/platform-browser';
import {RouteReuseStrategy} from '@angular/router';
import {IonicStorageModule} from '@ionic/storage-angular';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';

import {IonicModule, IonicRouteStrategy} from '@ionic/angular';

import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {FormsModule} from '@angular/forms';

import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {AppConfigService} from "./services/app-config.service";

import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';

import {JwtInterceptor} from './http-interceptors/jwt-interceptor';
import {StateStorageService} from './services/state-storage.service';
import {AuthGuard} from './guards/auth-guard';

import {SearchFormModule} from './components/searchlist/search-form/search-form.module';
import {DeviceControlModule} from './components/searchlist/device-control/device-control.module';
import {SearchFormComponent} from './components/searchlist/search-form/search-form.component';
import {DeviceControlComponent} from './components/searchlist/device-control/device-control.component';
import {SharedModule} from './shared.modules';
import {
    CombinedInventoryInputModule
} from './components/inputs/combined-inventory-input/combined-inventory-input.module';
import {
    CombinedInventoryInputComponent
} from './components/inputs/combined-inventory-input/combined-inventory-input.component';
import {PopupGuard} from './guards/popup.guard';
import {ErrorHandlerService} from './services/error-handler.service';
import {AdminOptionsComponent} from './components/admin/admin-options/admin-options.component';
import {AdminOptionsModule} from './components/admin/admin-options/admin-options.module';
import {SpecialOptionsModule} from './components/special/special-options/special-options.module';
import {FullDeviceModule} from './components/singledevice/full-device/full-device.module';
import {STORE_NAME} from "../environments/environment";
import {AppInitializer} from "./services/app-initializer";

export function TranslateLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export function InitApp(appInit: AppInitializer) {
    return () => appInit.init();
}

export function GetLocale(appState: StateStorageService) {
    return () => {
        return appState.locale
    };
}

registerLocaleData(localeDe, 'de');

@NgModule({
    declarations: [
        AppComponent
    ],
    entryComponents: [
        SearchFormComponent,
        DeviceControlComponent,
        CombinedInventoryInputComponent
    ],
    imports: [
        SharedModule,
        BrowserModule,
        IonicModule.forRoot(),
        IonicStorageModule.forRoot({name: STORE_NAME}),
        HttpClientModule,
        AppRoutingModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: TranslateLoaderFactory,
                deps: [HttpClient]
            }
        }),
        SearchFormModule,
        DeviceControlModule,
        AdminOptionsModule,
        SpecialOptionsModule,
        FullDeviceModule,
        CombinedInventoryInputModule,
        BrowserAnimationsModule,
        FormsModule
    ],
    providers: [
        AuthGuard,
        PopupGuard,
        StateStorageService,
        AppConfigService,
        {
            provide: APP_INITIALIZER,
            multi: true,
            deps: [AppInitializer],
            useFactory: InitApp
        },
        {
            provide: LOCALE_ID,  // not working dynamically use appState.locale in each place!!
            useValue: 'de'
            // deps: [StateStorageService],
            // useFactory: GetLocale
        },
        {provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true},
        {provide: RouteReuseStrategy, useClass: IonicRouteStrategy},
        {provide: ErrorHandler, useClass: ErrorHandlerService}
    ],
    exports: [
        AdminOptionsComponent
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
